import React from 'react';
import { ArrowUpRightIcon, CheckIcon } from 'lucide-react';
const plans = [{
  name: 'CAMPAIGN',
  title: 'Start with one experience.',
  description: 'A focused way to bring a product drop, local activation, or launch moment into the Sampler experience.',
  includes: ['Campaign direction', 'Experience setup', 'Campaign review view']
}, {
  name: 'PROGRAMME',
  title: 'Make product experience a channel.',
  description: 'For teams building a connected calendar of product moments across markets, audiences, or launches.',
  includes: ['Multi-campaign planning', 'Shared learning view', 'Programme support'],
  featured: true
}, {
  name: 'ENTERPRISE',
  title: 'Build the infrastructure together.',
  description: 'For organisations exploring a tailored product experience layer across brand, media, retail, and activation.',
  includes: ['Custom operating model', 'Partner integration direction', 'Dedicated planning']
}];
export function PricingSection() {
  return <section id="pricing" className="bg-white px-5 py-24 md:px-10 md:py-32" aria-labelledby="pricing-heading" data-id="element-616">
      <div className="mx-auto max-w-[1280px]" data-id="element-617">
        <div className="grid gap-8 border-b border-black/15 pb-12 md:grid-cols-[1fr_0.75fr] md:items-end" data-id="element-618">
          <div data-id="element-619">
            <p className="text-xs font-extrabold tracking-[0.16em] text-black/50" data-id="element-620">
              PRICING THAT FITS THE EXPERIENCE
            </p>
            <h2 id="pricing-heading" className="mt-5 font-display text-5xl font-bold leading-[0.88] md:text-7xl" data-id="element-621">
              Start with a drop.
              <br data-id="element-622" />
              Build a <span className="text-[#ff4d17]" data-id="element-623">programme.</span>
            </h2>
          </div>
          <p className="max-w-xl text-lg leading-relaxed text-black/70" data-id="element-624">
            Every product experience is shaped around its audience, location,
            partner model, and campaign ambition. Pricing is scoped with you —
            not guessed on a page.
          </p>
        </div>

        <div className="mt-12 grid gap-4 lg:grid-cols-3" data-id="element-625">
          {plans.map(plan => <article key={plan.name} className={`flex min-h-[440px] flex-col border p-7 md:p-8 ${plan.featured ? 'border-[#ff4d17] bg-[#ff4d17] text-black shadow-[10px_10px_0_#11110f]' : 'border-black/15 bg-[#f7f5ef]'}`} data-id="element-626">
              <p className="text-xs font-extrabold tracking-[0.14em] opacity-65" data-id="element-627">
                {plan.name}
              </p>
              <h3 className="mt-9 font-display text-4xl font-bold leading-[0.9]" data-id="element-628">
                {plan.title}
              </h3>
              <p className="mt-6 text-base leading-relaxed text-black/70" data-id="element-629">
                {plan.description}
              </p>

              <div className="mt-8 border-t border-current/20 pt-6" data-id="element-630">
                <p className="text-xs font-extrabold tracking-[0.12em]" data-id="element-631">
                  INCLUDED DIRECTION
                </p>
                <ul className="mt-4 space-y-3 text-sm font-semibold" data-id="element-632">
                  {plan.includes.map(item => <li key={item} className="flex gap-3" data-id="element-633">
                      <CheckIcon className="mt-0.5 shrink-0" size={16} aria-hidden="true" data-id="element-634" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto pt-8" data-id="element-635">
                <p className="text-sm font-bold" data-id="element-636">PRICING ON REQUEST</p>
                <a href="#start" className={`mt-4 inline-flex min-h-12 items-center gap-2 rounded-full px-5 text-sm font-extrabold ${plan.featured ? 'bg-black text-white hover:bg-[#11110f]/80' : 'bg-[#11110f] text-white hover:bg-black/75'}`} data-id="element-637">
                  TALK TO US <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-638" />
                </a>
              </div>
            </article>)}
        </div>
        <p className="mt-8 text-xs font-bold leading-relaxed text-black/55" data-id="element-639">
          Scope, availability, partner participation, and commercial terms are
          agreed per programme. This is an indicative service structure, not a
          published rate card.
        </p>
      </div>
    </section>;
}